import { cad, flutter, react } from "../data/frameworks";
import { Framework } from "../models/projectModel";

const BottomBar = () => {
  const iconList : Framework[] = [flutter, react, cad]; 
 
  return (
    <div className="flex flex-row flex-wrap gap-5 w-full justify-center my-16 pb-10">
      {iconList.map((e) => (
        <div key={e.key}>
          <img className="h-10" src={`/assets/icons/${e.icon}`} alt={e.name} />
        </div>
      ))}
    </div>
  );
};

export default BottomBar;
